export enum ActionTypes {
    OPEN_FORM = 'OPEN_FORM',
    CLOSE_FORM = 'CLOSE_FORM',

    FETCH_ALL_SONGS_START = 'FETCH_ALL_SONGS_START',
    FETCH_ALL_SONGS_SUCCESS = 'FETCH_ALL_SONGS_SUCCESS',
    FETCH_ALL_SONGS_FAILED = 'FETCH_ALL_SONGS_FAILED',

    POST_MUSIC_REQUEST_START = 'POST_MUSIC_REQUEST_START',
    POST_MUSIC_REQUEST_SUCCESS = 'POST_MUSIC_REQUEST_SUCCESS',
    POST_MUSIC_REQUEST_FAILED = 'POST_MUSIC_REQUEST_FAILED',

    SEARCH_TEXT = 'SEARCH_TEXT',
    SHOW_MUSIC_COMPONENT = 'SHOW_MUSIC_COMPONENT',
    HIDE_MUSIC_COMPONENT = 'HIDE_MUSIC_COMPONENT',

    GET_SINGLE_MUSIC = 'GET_SINGLE_MUSIC'
}